import { createContext, useState } from "react";
import { DrawerContextValue, DrawerProviderProps } from "./types";

export const DrawerContext = createContext<DrawerContextValue>({
  onClose: () => {
    console.warn("[DrawerContext]: used initial value for onClose method");
  },
  showDrawer: () => {
    console.warn("[DrawerContext]: used initial value for showDrawer method");
  },
  open: false,
  disabled: false,
  setDisabled: () => {},
  contentContext: [],
  setContentContext: () => {}
});

export function DrawerProvider({ children }: DrawerProviderProps) {
  const [open, setOpen] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [contentContext, setContentContext] = useState();


  const showDrawer = async () => {
    setOpen(true);
    console.log("[DrawerContext]: showDrawer called, open set to true");
  };

  function onClose() {
    setOpen(false);
  }

  return (
    <DrawerContext.Provider value={{ open, showDrawer, onClose, disabled, setDisabled, contentContext, setContentContext }}>
      {children}
    </DrawerContext.Provider>
  );
}
